import React, { useEffect, useState } from "react";
import {
  TextField,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Checkbox,
  Grid,
  FormGroup,
  FormControlLabel,
  Button,
  Menu,
  MenuItem,
  Pagination,
  Select,
} from "@mui/material";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import Norecords from "../../components/customHelpers/Norecords";
import Notify from "../../components/customHelpers/Notify";
import Loading from "../../components/customHelpers/Loading";
import SearchIcon from "@mui/icons-material/Search";
import Order from "../../actions/order";
import CancelIcon from "@mui/icons-material/Cancel";

import Notification from "../../components/customHelpers/Notification";
import {
  calculateTotalPaid,
  calculateTotalSumOrderProducts,
  formatNumber,
  getTimestamp,
} from "../../utils/utils";
import Product from "../../actions/product";
import Layout from "../../components/layout/Layout";
import Admin from "../../components/auth/Admin";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import jsPDF from "jspdf";
import DownloadIcon from "@mui/icons-material/Download";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import useTable from "../../components/customHelpers/usePaginationTable";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  image: {
    borderRadius: "55%",
    height: "45px",
    width: "45px",
  },
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  pageSizeSelect: {
    minWidth: 120,
    marginRight: theme.spacing(2),
  },
}));
const initialHeadCells = [
  { id: "customer", label: "Customer", isVisible: true },
  { id: "name", label: "Product Name", isVisible: true },
  { id: "sku", label: "Sku", isVisible: true },
  { id: "price", label: "Price", isVisible: true },
  { id: "quantity", label: "Quantity", isVisible: true },
  { id: "discount", label: "Discount", isVisible: true },
  { id: "totalPrice", label: "Total Price", isVisible: true },
  { id: "date", label: "Date", isVisible: true },
];
const OrderProductsFilter = () => {
  const classes = useStyles();
  const [headCells, setHeadCells] = useState(initialHeadCells);
  const hiddenColumns = headCells.filter((cell) => !cell.isVisible);
  const visibleColumns = headCells.filter((cell) => cell.isVisible);

  const [orderProducts, setOrderProducts] = useState([]);
  const [productLists, setProductLists] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { viewAllProductsLists } = Product();
  const [searchTerm, setSearchTerm] = useState("");
  const [inputValue, setInputValue] = useState("");
  const { NotifyMessage, notify, setNotify } = Notify();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { viewAllOrderProductsWithPages, viewOrderProductsPrice } = Order();
  const [totals, setTotals] = useState({
    totalPrice: 0,
    isClick: true,
  });
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const [filteredOrders, setFilteredOrders] = useState([]);
  const options = productLists.map((product) => ({
    label: `${product.product.sku} - ${product.product.name} - ${product.store?.locationName}`,
    product,
  }));
  const { loading, reload } = values;
  const [page, setPage] = useState(1);
  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  const pageSizes = [15, 25, 50, 100];
  useEffect(() => {
    getAllOrders();
  }, [page, limit, searchQuery, selectedProduct, startDate, endDate]);
  useEffect(() => {
    getProductData();
    getTotalPrice();
  }, []);
  useEffect(() => {
    getTotalPrice();
  }, [selectedProduct, startDate, endDate]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const getTotalPrice = () => {
    viewOrderProductsPrice(
      selectedProduct?.product.product.sku,
      startDate,
      endDate
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        setTotals({
          totalPrice: data.totalPrice || 0,
          isClick: true,
        });
      }
    });
  };
  const handleColumnToggle = (id) => {
    const updatedHeadCells = headCells.map((cell) =>
      cell.id === id ? { ...cell, isVisible: !cell.isVisible } : cell
    );
    setHeadCells(updatedHeadCells);
  };
  const handleSearchChange = (event, value) => {
    setPage(1);
    if (value) {
      setSelectedProduct(value);
      setTotals({ ...totals, isClick: true });
    }
  };
  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const getAllOrders = () => {
    setValues({ ...values, loading: true });
    viewAllOrderProductsWithPages(
      page,
      limit,
      selectedProduct?.product.product.sku,
      startDate,
      endDate
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        setOrderProducts(data.orders);

        setTotalPages(Math.ceil(data.total / limit));
        setActualTotal(data.pagination.total);
        setTot(data.pagination.totalPages);
      }
    });
  };
  const getProductData = () => {
    viewAllProductsLists().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.product) {
        setValues({
          ...values,
          loading: false,
        });
        setProductLists(data.product);
      }
    });
  };
  const handleStartDateChange = (newValue) => {
    setPage(1);
    setStartDate(newValue);
    setTotals({ ...totals, isClick: true });
  };

  const handleEndDateChange = (newValue) => {
    setPage(1);
    setEndDate(newValue);
    setTotals({ ...totals, isClick: true });
  };

  const exportToExcel = () => {
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);
    const headers = filteredHeadCells.map((cell) => cell.label);
    const data = [];

    orderProducts.forEach((order) => {
      const rowData = filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "customer":
            return order.order.customer.fullName;
          case "name":
            return order.productName;
          case "sku":
            return order.sku;
          case "price":
            return order.price;
          case "quantity":
            return order.quantity;
          case "discount":
            return order.discount;
          case "totalPrice":
            return formatNumber(order.totalPrice);
          case "date":
            return new Date(order.createdAt).toLocaleString();
          default:
            return "";
        }
      });
      data.push(rowData);
    });
    let totalPrice = 0;
    for (const op of orderProducts) {
      totalPrice += parseFloat(op.totalPrice || 0);
    }
    data.push([
      "Total Price",
      formatNumber(totalPrice),
      "",
      "",
      "",
      "",
      "",
      "",
    ]);
  
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Order");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const timestamp = getTimestamp();
    const sku = selectedProduct ? selectedProduct.product.product.sku : "";
    const filename = generateReportFilename(startDate, endDate, sku, timestamp);
    saveAs(blob, filename);
    saveAs(blob, `${filename}.xlsx`);
    handleClose();
  };
  const exportToPDF = () => {
    const doc = new jsPDF();
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);
    const headers = [filteredHeadCells.map((cell) => cell.label)];
    const data = [];
    orderProducts.forEach((op) => {
      const rowData = filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "customer":
            return op.order.customer.fullName;
          case "name":
            return op.productName;
          case "sku":
            return op.sku;
          case "price":
            return op.price;
          case "quantity":
            return op.quantity;
          case "discount":
            return op.discount;
          case "date":
            return new Date(op.createdAt).toLocaleString();
          case "totalPrice":
            return formatNumber(op.totalPrice);
          default:
            return "";
        }
      });
      data.push(rowData);
    });

    doc.autoTable({
      head: headers,
      body: data,
      styles: {
        fontSize: 10,
      },
      headStyles: {
        fillColor: [244, 151, 3],
        textColor: [20, 61, 89],
      },
    });
    let totalPrice = 0;

    for (const op of orderProducts) {
      totalPrice += parseFloat(op.totalPrice || 0);
    }

    const finalY = doc.lastAutoTable.finalY || 10;
    doc.text(
      `Total Price: ${formatNumber(totalPrice)}`,
      doc.internal.pageSize.getWidth() - 20,
      finalY + 10,
      { align: "right" }
    );

    const timestamp = getTimestamp();
    const sku = selectedProduct ? selectedProduct.product.product.sku : "";
    const filename = generateReportFilename(startDate, endDate, sku, timestamp);
    doc.save(`${filename}.pdf`);
    handleClose();
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const generateReportFilename = (startDate, endDate, sku, timestamp) => {
    const formattedStartDate = startDate
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "AllDates";
    const formattedEndDate = endDate ? dayjs(endDate).format("YYYY-MM-DD") : "";
    const formattedSKU = sku || "AllSKUs";

    return `${formattedStartDate}_${formattedEndDate}_${formattedSKU}_Sales-order-detail-report_${timestamp}`;
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const clearFilters = () => {
    setSearchTerm("");
    setSelectedProduct(null);
    setFilteredOrders([]);
    setInputValue("");
    setStartDate(null);
    setEndDate(null);
    setPage(1);
    setLimit(15);
    setTotals({ ...totals, isClick: true });
  };
  const handlePageChange = (event, newPage) => {
    setTotals({ ...totals, isClick: true });
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterSortingAndFiltering,
  } = useTable(orderProducts, initialHeadCells, filterFn);

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Sales Product Report
          </Typography>
          <Box display="flex" justifyContent="start" gap={2} m={1}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Order Start Date"
                value={startDate}
                onChange={handleStartDateChange}
                slotProps={{
                  field: { clearable: true },
                }}
              />
              <DatePicker
                label="Order End Date"
                value={endDate}
                onChange={handleEndDateChange}
                slotProps={{
                  field: { clearable: true },
                }}
              />
            </LocalizationProvider>

            <Box sx={{ width: "25%" }}>
              <Autocomplete
                options={searchTerm ? filteredOptions : []}
                fullWidth
                getOptionLabel={(option) => option.label}
                onChange={handleSearchChange}
                onInputChange={(event, newInputValue) =>
                  setInputValue(newInputValue)
                }
                value={selectedProduct} // Set the selected value
                inputValue={inputValue}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="SKU or Product Name"
                    variant="outlined"
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                )}
              />
            </Box>
            <Box display="flex" justifyContent="end" gap={2} m={1}>
              <Button
                variant="contained"
                onClick={clearFilters}
                startIcon={<ClearAllIcon />}
                sx={{
                  backgroundColor: "rgba(244,151,3,.8)",
                  color: "rgb(20,61,89)",
                  "&:hover": {
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)", // Darker on hover
                  },
                }}
              >
                Clear
              </Button>
              <div>
                <Button
                  variant="contained"
                  id="demo-positioned-button"
                  aria-controls={open ? "demo-positioned-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  startIcon={<DownloadIcon />}
                  sx={{
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)",
                    "&:hover": {
                      backgroundColor: "rgba(244,151,3,.8)",
                      color: "rgb(20,61,89)", // Darker on hover
                    },
                  }}
                >
                  Export
                </Button>
                <Menu
                  id="demo-positioned-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleMenuClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <MenuItem onClick={exportToPDF}>PDF</MenuItem>
                  <MenuItem onClick={exportToExcel}>Excel</MenuItem>
                </Menu>
              </div>
            </Box>
          </Box>
          <Grid container spacing={2}>
            <Grid
              item
              xs={hiddenColumns.length > 0 ? 9 : 12}
              className="card__body"
            >
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {visibleColumns.map((headCell) => (
                            <TableCell
                              className={
                                headCell.isVisible
                                  ? "table-cell-visible"
                                  : "table-cell-hidden"
                              }
                              key={headCell.id}
                              style={{
                                width: headCell.isVisible ? "auto" : "0",
                              }}
                            >
                              <Box
                                sx={{
                                  backgroundColor: "transparent", // Remove background color from Box
                                  "& .MuiSvgIcon-root": {
                                    backgroundColor: "transparent !important", // Remove background color from Checkbox icon
                                  },
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1, // Adjust the gap between Typography and Checkbox
                                }}
                              >
                                <Typography variant="subtitle1" noWrap>
                                  {headCell.label}
                                </Typography>
                                <Checkbox
                                  checked={headCell.isVisible}
                                  onChange={() =>
                                    handleColumnToggle(headCell.id)
                                  }
                                  icon={<CheckBoxOutlineBlankIcon />}
                                  checkedIcon={<CancelIcon />}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      backgroundColor: "transparent !important", // Remove background color from Checkbox icon
                                    },
                                  }}
                                />
                              </Box>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {recordsAfterSortingAndFiltering().length > 0 ? (
                          recordsAfterSortingAndFiltering().map((item) => (
                            <TableRow key={item.id}>
                              {visibleColumns.map((headCell) => (
                                <TableCell key={headCell.id}>
                                  {headCell.id === "customer"
                                    ? item.order?.customer.fullName
                                    : headCell.id === "name"
                                    ? item.productName
                                    : headCell.id === "sku"
                                    ? item.sku
                                    : headCell.id === "price"
                                    ? formatNumber(item.price)
                                    : headCell.id === "quantity"
                                    ? item.quantity
                                    : headCell.id === "discount"
                                    ? item.discount
                                    : headCell.id === "totalPrice"
                                    ? formatNumber(item.totalPrice)
                                    : headCell.id === "date"
                                    ? new Date(item.createdAt).toLocaleString()
                                    : null}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))
                        ) : (
                          <Norecords col={6} />
                        )}
                      </TableBody>
                    </Table>
                  </TblContainer>
                  <Box className={classes.paginationContainer}>
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2" style={{ marginRight: 8 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        className={classes.pageSizeSelect}
                        size="small"
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {" "}
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {orderProducts.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={
                          page === tot || orderProducts.length === 0
                        }
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                        disabled={orderProducts.length === 0}
                      />
                    )}
                  </Box>{" "}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-end",
                      flexDirection: "column",
                      p: 1,
                      gap: 1,
                      m: 1,
                      bgcolor: "background.paper",
                      borderRadius: 1,
                    }}
                  >
                    <div
                      style={{
                        marginRight: "35px",
                        fontWeight: "bold",
                        fontSize: "15px",
                      }}
                    >
                      Total Price: {formatNumber(totals.totalPrice)}
                    </div>
                  </Box>
                </Paper>
              )}
            </Grid>
            {hiddenColumns.length > 0 && (
              <Grid item xs={2} className="card__body" sx={{ marginLeft: 10 }}>
                <Typography variant="h6">Hidden Columns</Typography>
                <FormGroup sx={{ marginTop: 0 }}>
                  {hiddenColumns.map((headCell, index) => (
                    <FormControlLabel
                      key={headCell.id}
                      control={
                        <Checkbox
                          sx={{
                            "& .MuiSvgIcon-root": {
                              backgroundColor: "transparent",
                            },
                          }}
                          onChange={() => handleColumnToggle(headCell.id)}
                        />
                      }
                      label={headCell.label}
                      sx={{
                        marginBottom:
                          index === hiddenColumns.length - 1 ? 0 : 1,
                        "& .MuiFormControlLabel-label": {
                          marginTop: 0,
                        },
                      }}
                    />
                  ))}
                </FormGroup>
              </Grid>
            )}
            <Notification notify={notify} setNotify={setNotify} />
          </Grid>
        </div>
      </Admin>
    </Layout>
  );
};

export default OrderProductsFilter;
